module.exports = __webpack_public_path__ + "static/media/flask-0.c4d73573.svg";